import { z } from 'zod';

export const enableTwoFaSchema = (t: { required: string }) =>
  z.object({
    secret: z.string().min(1, t.required),
    pin: z.string().length(6).min(1, t.required),
  });

export type EnableTwoFaSchema = z.infer<ReturnType<typeof enableTwoFaSchema>>;
